export const featuresConstants = {
  claims: {
    type: 'claims',
    view: 'view claims',
  },

  dashboard: {
    type: 'dashboard',
    cards: {
      totalCalls: 'total calls',
      outgoingCalls: 'outgoing calls',
      inprogressCalls: 'inprogress calls',
      activeCalls: 'active calls',
    },
    graphs: {
      outboundCallsByDate: 'outbound calls by date',
      connectionRateByDate: 'connection rate by date',
      concurrentCallsByDate: 'concurrent calls',
    },
  },

  csvFieldMapper: {
    type: 'csv field mapper',
    viewEdit: 'view and edit csv field mapper',
  },

  callDialer: {
    type: 'calldialer',
    view: 'view call dialer',
  },

  activityLogs: {
    type: 'activity logs',
    view: 'view activity logs',
  },

  batchReports: {
    type: 'batch report',
    view: 'view batch reports',
    viewReportDetails: 'view batch report details',
    downloadReport: 'download batch report',
  },

  batches: {
    type: 'batches',
    create: 'create batch',
    start: 'start batch',
    view: 'View Batch',
    delete: 'delete batch',
    viewBatchDetails: 'View Batch Details',
  },

  clientManagement: {
    type: 'client management',
    add: 'add client',
    view: 'view client',
    archiveUnarchive: 'archive/unarchive client',
    update: 'update client',
  },

  featuresManagement: {
    type: 'features management',
    add: 'add feature',
    view: 'view feature',
    edit: 'edit feature',
  },

  roleManagement: {
    type: 'role management',
    add: 'add role',
    update: 'update role (archive/unarchive)',
    assignClients: 'assign clients to role',
    assignFeatures: 'assign features to role',
    view: 'View Role Management',
  },
};
